import {bildirimTercihiAl} from "./bildirimTercihi";

export const isUserActiveOnTab = (): boolean =>
    typeof document !== "undefined" &&
    document.visibilityState === "visible" &&
    document.hasFocus() &&
    typeof window !== "undefined" &&
    window.outerHeight > 0;

/**
 * Masaüstü bildirimi: yalnız Görünüm › Bildirimler'de "Masaüstü bildirimi" açıksa, tarayıcı izni verilmişse ve kullanıcı
 * bu sekmede değilse. İzin burada SORULMAZ (eskiden ilk hatada kendiliğinden soruluyordu); anahtar açılırken
 * bildirimTercihi.masaustuIzniIste sorar.
 */
export const showBrowserNotification = (title: string, body: string) => {
    if (!bildirimTercihiAl().masaustu) return;
    if (isUserActiveOnTab()) return;
    if (typeof window === "undefined" || !("Notification" in window)) return;
    if (Notification.permission !== "granted") return;
    try {
        new Notification(title, {body, icon: "/favicon.ico", badge: "/favicon.ico"});
    } catch (e) {
        /* bazı tarayıcılar (Android Chrome) yapıcıyı desteklemez */
    }
};
